import { useMemo } from "react";
import { TaskGrid } from "../../components/TaskGrid/TaskGrid";
import { useBoardViews } from "../../contexts/views/viewsContext";
import { OverlayOpener } from "../../layout/components/OverlayOpener";
import ViewTitle from "../../layout/components/ViewTitle";
import Enums from "../../types/enums";

export const AllTasksPage = () => {
  const { systemViews } = useBoardViews();

  const allTaskView = useMemo(
    () => systemViews.find((v) => v.ViewType === Enums.ViewType.AllTasks),
    [systemViews]
  );

  return (
    <OverlayOpener>
      <div className="row">
        <ViewTitle viewId={allTaskView?.Id} viewName={allTaskView.Name} />
      </div>
      <div className="row">
        <TaskGrid viewId={allTaskView?.Id} />
      </div>
    </OverlayOpener>
  );
};
